import React, { createElement } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import MainContent from './components/MainContent';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
const AppContent = () => {
  const {
    theme
  } = useTheme();
  const isLightMode = theme === 'light';
  const isDarkMode = theme === 'dark';
  return <div className="min-h-screen bg-background dark:bg-dark-background transition-colors relative" data-id="element-0">
      <Helmet data-id="element-1">
        <link rel="icon" href="https://uploadthingy.s3.us-west-1.amazonaws.com/eQ9gtgpbgwxobbjvXTVf1k/LinkedIn.svg" data-id="element-2" />
        <title data-id="element-3">LinkedIn AI Tools</title>
        {/* Microsoft Clarity Analytics */}
        <script type="text/javascript" data-id="element-4">
          {`
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "tdaqm2q6b8");
          `}
        </script>
      </Helmet>
      {/* Desktop floating background - only shown in light mode */}
      {isLightMode && <div className="absolute inset-0 hidden md:block pointer-events-none overflow-hidden" data-id="element-5">
          <div className="w-full h-full opacity-90" style={{
        backgroundImage: `url('https://uploadthingy.s3.us-west-1.amazonaws.com/2q6eMW8hAH4SzpVfhub5it/backg1.png')`,
        backgroundSize: 'contain',
        backgroundPosition: 'top left',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        animation: 'floatBackground 10s ease-in-out infinite'
      }} data-id="element-6" />
        </div>}
      {/* Desktop floating background - only shown in dark mode */}
      {isDarkMode && <div className="absolute inset-0 hidden md:block pointer-events-none overflow-hidden" data-id="element-7">
          <div className="w-full h-full opacity-90" style={{
        backgroundImage: `url('https://uploadthingy.s3.us-west-1.amazonaws.com/6deamKNyUYmTKmH9bGd3iG/backg2.png')`,
        backgroundSize: '40%',
        backgroundPosition: 'top left',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        animation: 'floatBackground 10s ease-in-out infinite'
      }} data-id="element-8" />
        </div>}
      {/* Mobile background - only shown in light mode */}
      {isLightMode && <div className="min-h-screen md:hidden fixed inset-0 z-0 opacity-90" style={{
      backgroundImage: `url('https://uploadthingy.s3.us-west-1.amazonaws.com/aaAgnxjMvbY7Pg9xTD3FWJ/backgMobile.png')`,
      backgroundSize: 'contain',
      backgroundPosition: 'top right',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-9" />}
      {/* Animation keyframes */}
      <style jsx data-id="element-10">{`
        @keyframes floatBackground {
          0% {
            transform: translate(0, 0) scale(1);
            opacity: 0.92;
          }
          25% {
            transform: translate(12px, 8px) scale(1.02);
            opacity: 1;
          }
          50% {
            transform: translate(15px, 12px) scale(1.03);
            opacity: 0.96;
          }
          75% {
            transform: translate(8px, 15px) scale(1.02);
            opacity: 0.94;
          }
          100% {
            transform: translate(0, 0) scale(1);
            opacity: 0.92;
          }
        }
      `}</style>
      {/* Content */}
      <div className="relative z-10" data-id="element-11">
        <Header data-id="element-12" />
        <div className="flex flex-col md:flex-row max-w-full md:max-w-[1128px] mx-auto" data-id="element-13">
          <Sidebar data-id="element-14" />
          <MainContent data-id="element-15" />
        </div>
      </div>
    </div>;
};
export function App() {
  return <HelmetProvider data-id="element-16">
      <ThemeProvider data-id="element-17">
        <AppContent data-id="element-18" />
      </ThemeProvider>
    </HelmetProvider>;
}